import { detectPdfOrientation } from "pages/flyer/builder/utils/detectPdfOrientation";
import { setStoredOrientation } from "pages/flyer/builder/utils/orientationStorage";

// Opens an auto-imported PDF in its own orientation: seeds the first render and returns the URL param value (#2581).
export const seedImportOrientation = async (
  fileLink: string | null,
  designId: string,
  campaignId: string
): Promise<string | null> => {
  if (!fileLink) return null;
  const orientation = await detectPdfOrientation(fileLink);
  if (!orientation) return null;
  setStoredOrientation(orientation, designId, campaignId);
  return orientation.toLowerCase();
};
